import React, { useState } from 'react';
import { Modal, Button, Spinner } from 'react-bootstrap';
import { ativarEventoRsvp } from '~/Services/Service';

const extrairMensagemErro = (err, fallback) => {
  if (err && err.message) return err.message;
  if (typeof err === 'string') return err;
  return fallback;
};

const AtivarEventoModal = ({ evento, eventoAtivo, onClose }) => {
  const [loading, setLoading] = useState(false);

  if (!evento) return null;

  const ativar = !evento.ativo;

  const handleConfirmar = () => {
    setLoading(true);
    ativarEventoRsvp(evento.codigo, ativar)
      .then(() => {
        onClose(true);
      })
      .catch((err) => {
        const msg = extrairMensagemErro(
          err,
          'Erro ao atualizar status do evento.'
        );
        // Exibe erro no modal antes de fechar
        alert(msg);
        setLoading(false);
      });
  };

  const renderTexto = () => {
    if (ativar) {
      if (eventoAtivo && eventoAtivo.codigo !== evento.codigo) {
        return (
          <p>
            Ao ativar <strong>{evento.nome_evento}</strong>, o evento atual (
            <strong>{eventoAtivo.nome_evento}</strong>) será desativado
            automaticamente.
            <br />
            <br />
            Deseja continuar?
          </p>
        );
      }
      return (
        <p>
          Deseja ativar <strong>{evento.nome_evento}</strong>?
        </p>
      );
    }
    return (
      <p>
        Deseja desativar <strong>{evento.nome_evento}</strong>?
        <br />
        <br />
        <em className="text-muted">
          Os convidados verão a mensagem &quot;evento encerrado&quot; ao
          acessarem a landing page.
        </em>
      </p>
    );
  };

  return (
    <Modal show onHide={() => onClose(false)}>
      <Modal.Header closeButton>
        <Modal.Title>{ativar ? 'Ativar' : 'Desativar'} Evento</Modal.Title>
      </Modal.Header>
      <Modal.Body>{renderTexto()}</Modal.Body>
      <Modal.Footer>
        <Button
          variant="secondary"
          onClick={() => onClose(false)}
          disabled={loading}
        >
          Cancelar
        </Button>
        <Button
          variant={ativar ? 'success' : 'warning'}
          onClick={handleConfirmar}
          disabled={loading}
        >
          {loading ? (
            <>
              <Spinner
                as="span"
                animation="border"
                size="sm"
                className="mr-1"
              />
              Processando...
            </>
          ) : (
            'Confirmar'
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AtivarEventoModal;
